import tr, { useContext as ge, createContext as Me, useMemo as nr, useId as or, forwardRef as O } from "react";
function ye(e) {
  return Object.keys(e);
}
function se(e) {
  return e && typeof e == "object" && !Array.isArray(e);
}
function Oe(e, r) {
  const t = { ...e }, n = r;
  return se(e) && se(r) && Object.keys(r).forEach((o) => {
    se(n[o]) && o in e ? t[o] = Oe(t[o], n[o]) : t[o] = n[o];
  }), t;
}
function ar(e) {
  return e.replace(/[A-Z]/g, (r) => `-${r.toLowerCase()}`);
}
function Re(e) {
  return e === "0rem" ? "0rem" : `calc(${e} * var(--mantine-scale))`;
}
function Ie(e, { shouldScale: r = !1 } = {}) {
  function t(n) {
    if (n === 0 || n === "0")
      return `0${e}`;
    if (typeof n == "number") {
      const o = `${n / 16}${e}`;
      return r ? Re(o) : o;
    }
    if (typeof n == "string") {
      if (n === "" || n.startsWith("calc(") || n.startsWith("clamp(") || n.includes("rgba("))
        return n;
      if (n.includes(","))
        return n.split(",").map((a) => t(a)).join(",");
      if (n.includes(" "))
        return n.split(" ").map((a) => t(a)).join(" ");
      const o = n.replace("px", "");
      if (!Number.isNaN(Number(o))) {
        const a = `${Number(o) / 16}${e}`;
        return r ? Re(a) : a;
      }
    }
    return n;
  }
  return t;
}
const s = Ie("rem", { shouldScale: !0 }), Rt = Ie("em");
function be(e) {
  return Object.keys(e).reduce((r, t) => (e[t] !== void 0 && (r[t] = e[t]), r), {});
}
function Fe(e) {
  if (typeof e == "number")
    return !0;
  if (typeof e == "string") {
    if (e.startsWith("calc(") || e.startsWith("var(") || e.includes(" ") && e.trim() !== "")
      return !0;
    const r = /^[+-]?[0-9]+(\.[0-9]+)?(px|em|rem|ex|ch|lh|rlh|vw|vh|vmin|vmax|vb|vi|svw|svh|lvw|lvh|dvw|dvh|cm|mm|in|pt|pc|q|cqw|cqh|cqi|cqb|cqmin|cqmax|%)?$/;
    return e.trim().split(/\s+/).every((n) => r.test(n));
  }
  return !1;
}
var Q = { exports: {} }, H = {};
var xe;
function ir() {
  if (xe) return H;
  xe = 1;
  var e = /* @__PURE__ */ Symbol.for("react.transitional.element"), r = /* @__PURE__ */ Symbol.for("react.fragment");
  function t(n, o, a) {
    var c = null;
    if (a !== void 0 && (c = "" + a), o.key !== void 0 && (c = "" + o.key), "key" in o) {
      a = {};
      for (var f in o)
        f !== "key" && (a[f] = o[f]);
    } else a = o;
    return o = a.ref, {
      $$typeof: e,
      type: n,
      key: c,
      ref: o !== void 0 ? o : null,
      props: a
    };
  }
  return H.Fragment = r, H.jsx = t, H.jsxs = t, H;
}
var Y = {};
var Ee;
function sr() {
  return Ee || (Ee = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(i) {
      if (i == null) return null;
      if (typeof i == "function")
        return i.$$typeof === oe ? null : i.displayName || i.name || null;
      if (typeof i == "string") return i;
      switch (i) {
        case R:
          return "Fragment";
        case A:
          return "Profiler";
        case x:
          return "StrictMode";
        case _:
          return "Suspense";
        case P:
          return "SuspenseList";
        case ne:
          return "Activity";
      }
      if (typeof i == "object")
        switch (typeof i.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), i.$$typeof) {
          case w:
            return "Portal";
          case $:
            return i.displayName || "Context";
          case j:
            return (i._context.displayName || "Context") + ".Consumer";
          case E:
            var l = i.render;
            return i = i.displayName, i || (i = l.displayName || l.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
          case te:
            return l = i.displayName || null, l !== null ? l : e(i.type) || "Memo";
          case I:
            l = i._payload, i = i._init;
            try {
              return e(i(l));
            } catch {
            }
        }
      return null;
    }
    function r(i) {
      return "" + i;
    }
    function t(i) {
      try {
        r(i);
        var l = !1;
      } catch {
        l = !0;
      }
      if (l) {
        l = console;
        var y = l.error, h = typeof Symbol == "function" && Symbol.toStringTag && i[Symbol.toStringTag] || i.constructor.name || "Object";
        return y.call(
          l,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          h
        ), r(i);
      }
    }
    function n(i) {
      if (i === R) return "<>";
      if (typeof i == "object" && i !== null && i.$$typeof === I)
        return "<...>";
      try {
        var l = e(i);
        return l ? "<" + l + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function o() {
      var i = F.A;
      return i === null ? null : i.getOwner();
    }
    function a() {
      return Error("react-stack-top-frame");
    }
    function c(i) {
      if (U.call(i, "key")) {
        var l = Object.getOwnPropertyDescriptor(i, "key").get;
        if (l && l.isReactWarning) return !1;
      }
      return i.key !== void 0;
    }
    function f(i, l) {
      function y() {
        V || (V = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          l
        ));
      }
      y.isReactWarning = !0, Object.defineProperty(i, "key", {
        get: y,
        configurable: !0
      });
    }
    function u() {
      var i = e(this.type);
      return q[i] || (q[i] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), i = this.props.ref, i !== void 0 ? i : null;
    }
    function p(i, l, y, h, M, z) {
      var v = y.ref;
      return i = {
        $$typeof: S,
        type: i,
        key: l,
        props: y,
        _owner: h
      }, (v !== void 0 ? v : null) !== null ? Object.defineProperty(i, "ref", {
        enumerable: !1,
        get: u
      }) : Object.defineProperty(i, "ref", { enumerable: !1, value: null }), i._store = {}, Object.defineProperty(i._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(i, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(i, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: M
      }), Object.defineProperty(i, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: z
      }), Object.freeze && (Object.freeze(i.props), Object.freeze(i)), i;
    }
    function m(i, l, y, h, M, z) {
      var v = l.children;
      if (v !== void 0)
        if (h)
          if (ae(v)) {
            for (h = 0; h < v.length; h++)
              d(v[h]);
            Object.freeze && Object.freeze(v);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else d(v);
      if (U.call(l, "key")) {
        v = e(i);
        var C = Object.keys(l).filter(function(ie) {
          return ie !== "key";
        });
        h = 0 < C.length ? "{key: someKey, " + C.join(": ..., ") + ": ...}" : "{key: someKey}", X[v + h] || (C = 0 < C.length ? "{" + C.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          h,
          v,
          C,
          v
        ), X[v + h] = !0);
      }
      if (v = null, y !== void 0 && (t(y), v = "" + y), c(l) && (t(l.key), v = "" + l.key), "key" in l) {
        y = {};
        for (var W in l)
          W !== "key" && (y[W] = l[W]);
      } else y = l;
      return v && f(
        y,
        typeof i == "function" ? i.displayName || i.name || "Unknown" : i
      ), p(
        i,
        v,
        y,
        o(),
        M,
        z
      );
    }
    function d(i) {
      g(i) ? i._store && (i._store.validated = 1) : typeof i == "object" && i !== null && i.$$typeof === I && (i._payload.status === "fulfilled" ? g(i._payload.value) && i._payload.value._store && (i._payload.value._store.validated = 1) : i._store && (i._store.validated = 1));
    }
    function g(i) {
      return typeof i == "object" && i !== null && i.$$typeof === S;
    }
    var b = tr, S = /* @__PURE__ */ Symbol.for("react.transitional.element"), w = /* @__PURE__ */ Symbol.for("react.portal"), R = /* @__PURE__ */ Symbol.for("react.fragment"), x = /* @__PURE__ */ Symbol.for("react.strict_mode"), A = /* @__PURE__ */ Symbol.for("react.profiler"), j = /* @__PURE__ */ Symbol.for("react.consumer"), $ = /* @__PURE__ */ Symbol.for("react.context"), E = /* @__PURE__ */ Symbol.for("react.forward_ref"), _ = /* @__PURE__ */ Symbol.for("react.suspense"), P = /* @__PURE__ */ Symbol.for("react.suspense_list"), te = /* @__PURE__ */ Symbol.for("react.memo"), I = /* @__PURE__ */ Symbol.for("react.lazy"), ne = /* @__PURE__ */ Symbol.for("react.activity"), oe = /* @__PURE__ */ Symbol.for("react.client.reference"), F = b.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, U = Object.prototype.hasOwnProperty, ae = Array.isArray, L = console.createTask ? console.createTask : function() {
      return null;
    };
    b = {
      react_stack_bottom_frame: function(i) {
        return i();
      }
    };
    var V, q = {}, G = b.react_stack_bottom_frame.bind(
      b,
      a
    )(), J = L(n(a)), X = {};
    Y.Fragment = R, Y.jsx = function(i, l, y) {
      var h = 1e4 > F.recentlyCreatedOwnerStacks++;
      return m(
        i,
        l,
        y,
        !1,
        h ? Error("react-stack-top-frame") : G,
        h ? L(n(i)) : J
      );
    }, Y.jsxs = function(i, l, y) {
      var h = 1e4 > F.recentlyCreatedOwnerStacks++;
      return m(
        i,
        l,
        y,
        !0,
        h ? Error("react-stack-top-frame") : G,
        h ? L(n(i)) : J
      );
    };
  })()), Y;
}
var Te;
function cr() {
  return Te || (Te = 1, process.env.NODE_ENV === "production" ? Q.exports = ir() : Q.exports = sr()), Q.exports;
}
var T = cr();
function B(e, r = "size", t = !0) {
  if (e !== void 0)
    return Fe(e) ? t ? s(e) : e : `var(--${r}-${e})`;
}
function xt(e) {
  return B(e, "mantine-spacing");
}
function Et(e) {
  return e === void 0 ? "var(--mantine-radius-default)" : B(e, "mantine-radius");
}
function Tt(e) {
  return B(e, "mantine-font-size");
}
function _t(e) {
  return B(e, "mantine-line-height", !1);
}
function kt(e) {
  if (e)
    return B(e, "mantine-shadow", !1);
}
function wt(e) {
  return e;
}
function Le(e) {
  var r, t, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (r = 0; r < o; r++) e[r] && (t = Le(e[r])) && (n && (n += " "), n += t);
  } else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function K() {
  for (var e, r, t = 0, n = "", o = arguments.length; t < o; t++) (e = arguments[t]) && (r = Le(e)) && (n && (n += " "), n += r);
  return n;
}
const fr = {};
function lr(e) {
  const r = {};
  return e.forEach((t) => {
    Object.entries(t).forEach(([n, o]) => {
      r[n] ? r[n] = K(r[n], o) : r[n] = o;
    });
  }), r;
}
function he({ theme: e, classNames: r, props: t, stylesCtx: n }) {
  const a = (Array.isArray(r) ? r : [r]).map(
    (c) => typeof c == "function" ? c(e, t, n) : c || fr
  );
  return lr(a);
}
function de({ theme: e, styles: r, props: t, stylesCtx: n }) {
  return (Array.isArray(r) ? r : [r]).reduce((a, c) => typeof c == "function" ? { ...a, ...c(e, t, n) } : { ...a, ...c }, {});
}
const ur = Me(null);
function N() {
  const e = ge(ur);
  if (!e)
    throw new Error("[@mantine/core] MantineProvider was not found in tree");
  return e;
}
function Ct() {
  return N().cssVariablesResolver;
}
function dr() {
  return N().classNamesPrefix;
}
function pr() {
  return N().getStyleNonce;
}
function mr() {
  return N().withStaticClasses;
}
function gr() {
  return N().headless;
}
function yr() {
  return N().stylesTransform?.sx;
}
function br() {
  return N().stylesTransform?.styles;
}
function Nt() {
  return N().env || "default";
}
function hr(e) {
  return /^#?([0-9A-F]{3}){1,2}([0-9A-F]{2})?$/i.test(e);
}
function vr(e) {
  let r = e.replace("#", "");
  if (r.length === 3) {
    const c = r.split("");
    r = [
      c[0],
      c[0],
      c[1],
      c[1],
      c[2],
      c[2]
    ].join("");
  }
  if (r.length === 8) {
    const c = parseInt(r.slice(6, 8), 16) / 255;
    return {
      r: parseInt(r.slice(0, 2), 16),
      g: parseInt(r.slice(2, 4), 16),
      b: parseInt(r.slice(4, 6), 16),
      a: c
    };
  }
  const t = parseInt(r, 16), n = t >> 16 & 255, o = t >> 8 & 255, a = t & 255;
  return {
    r: n,
    g: o,
    b: a,
    a: 1
  };
}
function $r(e) {
  const [r, t, n, o] = e.replace(/[^0-9,./]/g, "").split(/[/,]/).map(Number);
  return { r, g: t, b: n, a: o === void 0 ? 1 : o };
}
function Sr(e) {
  const r = /^hsla?\(\s*(\d+)\s*,\s*(\d+%)\s*,\s*(\d+%)\s*(,\s*(0?\.\d+|\d+(\.\d+)?))?\s*\)$/i, t = e.match(r);
  if (!t)
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    };
  const n = parseInt(t[1], 10), o = parseInt(t[2], 10) / 100, a = parseInt(t[3], 10) / 100, c = t[5] ? parseFloat(t[5]) : void 0, f = (1 - Math.abs(2 * a - 1)) * o, u = n / 60, p = f * (1 - Math.abs(u % 2 - 1)), m = a - f / 2;
  let d, g, b;
  return u >= 0 && u < 1 ? (d = f, g = p, b = 0) : u >= 1 && u < 2 ? (d = p, g = f, b = 0) : u >= 2 && u < 3 ? (d = 0, g = f, b = p) : u >= 3 && u < 4 ? (d = 0, g = p, b = f) : u >= 4 && u < 5 ? (d = p, g = 0, b = f) : (d = f, g = 0, b = p), {
    r: Math.round((d + m) * 255),
    g: Math.round((g + m) * 255),
    b: Math.round((b + m) * 255),
    a: c || 1
  };
}
function ve(e) {
  return hr(e) ? vr(e) : e.startsWith("rgb") ? $r(e) : e.startsWith("hsl") ? Sr(e) : {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  };
}
function Z(e, r) {
  if (e.startsWith("var("))
    return `color-mix(in srgb, ${e}, black ${r * 100}%)`;
  const { r: t, g: n, b: o, a } = ve(e), c = 1 - r, f = (u) => Math.round(u * c);
  return `rgba(${f(t)}, ${f(n)}, ${f(o)}, ${a})`;
}
function Rr(e, r) {
  return typeof e.primaryShade == "number" ? e.primaryShade : r === "dark" ? e.primaryShade.dark : e.primaryShade.light;
}
function ce(e) {
  return e <= 0.03928 ? e / 12.92 : ((e + 0.055) / 1.055) ** 2.4;
}
function xr(e) {
  const r = e.match(/oklch\((.*?)%\s/);
  return r ? parseFloat(r[1]) : null;
}
function Er(e) {
  if (e.startsWith("oklch("))
    return (xr(e) || 0) / 100;
  const { r, g: t, b: n } = ve(e), o = r / 255, a = t / 255, c = n / 255, f = ce(o), u = ce(a), p = ce(c);
  return 0.2126 * f + 0.7152 * u + 0.0722 * p;
}
function D(e, r = 0.179) {
  return e.startsWith("var(") ? !1 : Er(e) > r;
}
function ee({
  color: e,
  theme: r,
  colorScheme: t
}) {
  if (typeof e != "string")
    throw new Error(
      `[@mantine/core] Failed to parse color. Expected color to be a string, instead got ${typeof e}`
    );
  if (e === "bright")
    return {
      color: e,
      value: t === "dark" ? r.white : r.black,
      shade: void 0,
      isThemeColor: !1,
      isLight: D(
        t === "dark" ? r.white : r.black,
        r.luminanceThreshold
      ),
      variable: "--mantine-color-bright"
    };
  if (e === "dimmed")
    return {
      color: e,
      value: t === "dark" ? r.colors.dark[2] : r.colors.gray[7],
      shade: void 0,
      isThemeColor: !1,
      isLight: D(
        t === "dark" ? r.colors.dark[2] : r.colors.gray[6],
        r.luminanceThreshold
      ),
      variable: "--mantine-color-dimmed"
    };
  if (e === "white" || e === "black")
    return {
      color: e,
      value: e === "white" ? r.white : r.black,
      shade: void 0,
      isThemeColor: !1,
      isLight: D(
        e === "white" ? r.white : r.black,
        r.luminanceThreshold
      ),
      variable: `--mantine-color-${e}`
    };
  const [n, o] = e.split("."), a = o ? Number(o) : void 0, c = n in r.colors;
  if (c) {
    const f = a !== void 0 ? r.colors[n][a] : r.colors[n][Rr(r, t || "light")];
    return {
      color: n,
      value: f,
      shade: a,
      isThemeColor: c,
      isLight: D(f, r.luminanceThreshold),
      variable: o ? `--mantine-color-${n}-${a}` : `--mantine-color-${n}-filled`
    };
  }
  return {
    color: e,
    value: e,
    isThemeColor: c,
    isLight: D(e, r.luminanceThreshold),
    shade: a,
    variable: void 0
  };
}
function _e(e, r) {
  const t = ee({ color: e || r.primaryColor, theme: r });
  return t.variable ? `var(${t.variable})` : e;
}
function ke(e, r) {
  const t = {
    from: e?.from || r.defaultGradient.from,
    to: e?.to || r.defaultGradient.to,
    deg: e?.deg ?? r.defaultGradient.deg ?? 0
  }, n = _e(t.from, r), o = _e(t.to, r);
  return `linear-gradient(${t.deg}deg, ${n} 0%, ${o} 100%)`;
}
function k(e, r) {
  if (typeof e != "string" || r > 1 || r < 0)
    return "rgba(0, 0, 0, 1)";
  if (e.startsWith("var(")) {
    const a = (1 - r) * 100;
    return `color-mix(in srgb, ${e}, transparent ${a}%)`;
  }
  if (e.startsWith("oklch"))
    return e.includes("/") ? e.replace(/\/\s*[\d.]+\s*\)/, `/ ${r})`) : e.replace(")", ` / ${r})`);
  const { r: t, g: n, b: o } = ve(e);
  return `rgba(${t}, ${n}, ${o}, ${r})`;
}
const At = k, Tr = ({
  color: e,
  theme: r,
  variant: t,
  gradient: n,
  autoContrast: o
}) => {
  const a = ee({ color: e, theme: r }), c = typeof o == "boolean" ? o : r.autoContrast;
  if (t === "none")
    return {
      background: "transparent",
      hover: "transparent",
      color: "inherit",
      border: "none"
    };
  if (t === "filled") {
    const f = c && a.isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)";
    return a.isThemeColor ? a.shade === void 0 ? {
      background: `var(--mantine-color-${e}-filled)`,
      hover: `var(--mantine-color-${e}-filled-hover)`,
      color: f,
      border: `${s(1)} solid transparent`
    } : {
      background: `var(--mantine-color-${a.color}-${a.shade})`,
      hover: `var(--mantine-color-${a.color}-${a.shade === 9 ? 8 : a.shade + 1})`,
      color: f,
      border: `${s(1)} solid transparent`
    } : {
      background: e,
      hover: Z(e, 0.1),
      color: f,
      border: `${s(1)} solid transparent`
    };
  }
  if (t === "light") {
    if (a.isThemeColor) {
      if (a.shade === void 0)
        return {
          background: `var(--mantine-color-${e}-light)`,
          hover: `var(--mantine-color-${e}-light-hover)`,
          color: `var(--mantine-color-${e}-light-color)`,
          border: `${s(1)} solid transparent`
        };
      const f = r.colors[a.color][a.shade];
      return {
        background: k(f, 0.1),
        hover: k(f, 0.12),
        color: `var(--mantine-color-${a.color}-${Math.min(a.shade, 6)})`,
        border: `${s(1)} solid transparent`
      };
    }
    return {
      background: k(e, 0.1),
      hover: k(e, 0.12),
      color: e,
      border: `${s(1)} solid transparent`
    };
  }
  if (t === "outline")
    return a.isThemeColor ? a.shade === void 0 ? {
      background: "transparent",
      hover: `var(--mantine-color-${e}-outline-hover)`,
      color: `var(--mantine-color-${e}-outline)`,
      border: `${s(1)} solid var(--mantine-color-${e}-outline)`
    } : {
      background: "transparent",
      hover: k(r.colors[a.color][a.shade], 0.05),
      color: `var(--mantine-color-${a.color}-${a.shade})`,
      border: `${s(1)} solid var(--mantine-color-${a.color}-${a.shade})`
    } : {
      background: "transparent",
      hover: k(e, 0.05),
      color: e,
      border: `${s(1)} solid ${e}`
    };
  if (t === "subtle") {
    if (a.isThemeColor) {
      if (a.shade === void 0)
        return {
          background: "transparent",
          hover: `var(--mantine-color-${e}-light-hover)`,
          color: `var(--mantine-color-${e}-light-color)`,
          border: `${s(1)} solid transparent`
        };
      const f = r.colors[a.color][a.shade];
      return {
        background: "transparent",
        hover: k(f, 0.12),
        color: `var(--mantine-color-${a.color}-${Math.min(a.shade, 6)})`,
        border: `${s(1)} solid transparent`
      };
    }
    return {
      background: "transparent",
      hover: k(e, 0.12),
      color: e,
      border: `${s(1)} solid transparent`
    };
  }
  return t === "transparent" ? a.isThemeColor ? a.shade === void 0 ? {
    background: "transparent",
    hover: "transparent",
    color: `var(--mantine-color-${e}-light-color)`,
    border: `${s(1)} solid transparent`
  } : {
    background: "transparent",
    hover: "transparent",
    color: `var(--mantine-color-${a.color}-${Math.min(a.shade, 6)})`,
    border: `${s(1)} solid transparent`
  } : {
    background: "transparent",
    hover: "transparent",
    color: e,
    border: `${s(1)} solid transparent`
  } : t === "white" ? a.isThemeColor ? a.shade === void 0 ? {
    background: "var(--mantine-color-white)",
    hover: Z(r.white, 0.01),
    color: `var(--mantine-color-${e}-filled)`,
    border: `${s(1)} solid transparent`
  } : {
    background: "var(--mantine-color-white)",
    hover: Z(r.white, 0.01),
    color: `var(--mantine-color-${a.color}-${a.shade})`,
    border: `${s(1)} solid transparent`
  } : {
    background: "var(--mantine-color-white)",
    hover: Z(r.white, 0.01),
    color: e,
    border: `${s(1)} solid transparent`
  } : t === "gradient" ? {
    background: ke(n, r),
    hover: ke(n, r),
    color: "var(--mantine-color-white)",
    border: "none"
  } : t === "default" ? {
    background: "var(--mantine-color-default)",
    hover: "var(--mantine-color-default-hover)",
    color: "var(--mantine-color-default-color)",
    border: `${s(1)} solid var(--mantine-color-default-border)`
  } : {};
}, _r = {
  dark: [
    "#C9C9C9",
    "#b8b8b8",
    "#828282",
    "#696969",
    "#424242",
    "#3b3b3b",
    "#2e2e2e",
    "#242424",
    "#1f1f1f",
    "#141414"
  ],
  gray: [
    "#f8f9fa",
    "#f1f3f5",
    "#e9ecef",
    "#dee2e6",
    "#ced4da",
    "#adb5bd",
    "#868e96",
    "#495057",
    "#343a40",
    "#212529"
  ],
  red: [
    "#fff5f5",
    "#ffe3e3",
    "#ffc9c9",
    "#ffa8a8",
    "#ff8787",
    "#ff6b6b",
    "#fa5252",
    "#f03e3e",
    "#e03131",
    "#c92a2a"
  ],
  pink: [
    "#fff0f6",
    "#ffdeeb",
    "#fcc2d7",
    "#faa2c1",
    "#f783ac",
    "#f06595",
    "#e64980",
    "#d6336c",
    "#c2255c",
    "#a61e4d"
  ],
  grape: [
    "#f8f0fc",
    "#f3d9fa",
    "#eebefa",
    "#e599f7",
    "#da77f2",
    "#cc5de8",
    "#be4bdb",
    "#ae3ec9",
    "#9c36b5",
    "#862e9c"
  ],
  violet: [
    "#f3f0ff",
    "#e5dbff",
    "#d0bfff",
    "#b197fc",
    "#9775fa",
    "#845ef7",
    "#7950f2",
    "#7048e8",
    "#6741d9",
    "#5f3dc4"
  ],
  indigo: [
    "#edf2ff",
    "#dbe4ff",
    "#bac8ff",
    "#91a7ff",
    "#748ffc",
    "#5c7cfa",
    "#4c6ef5",
    "#4263eb",
    "#3b5bdb",
    "#364fc7"
  ],
  blue: [
    "#e7f5ff",
    "#d0ebff",
    "#a5d8ff",
    "#74c0fc",
    "#4dabf7",
    "#339af0",
    "#228be6",
    "#1c7ed6",
    "#1971c2",
    "#1864ab"
  ],
  cyan: [
    "#e3fafc",
    "#c5f6fa",
    "#99e9f2",
    "#66d9e8",
    "#3bc9db",
    "#22b8cf",
    "#15aabf",
    "#1098ad",
    "#0c8599",
    "#0b7285"
  ],
  teal: [
    "#e6fcf5",
    "#c3fae8",
    "#96f2d7",
    "#63e6be",
    "#38d9a9",
    "#20c997",
    "#12b886",
    "#0ca678",
    "#099268",
    "#087f5b"
  ],
  green: [
    "#ebfbee",
    "#d3f9d8",
    "#b2f2bb",
    "#8ce99a",
    "#69db7c",
    "#51cf66",
    "#40c057",
    "#37b24d",
    "#2f9e44",
    "#2b8a3e"
  ],
  lime: [
    "#f4fce3",
    "#e9fac8",
    "#d8f5a2",
    "#c0eb75",
    "#a9e34b",
    "#94d82d",
    "#82c91e",
    "#74b816",
    "#66a80f",
    "#5c940d"
  ],
  yellow: [
    "#fff9db",
    "#fff3bf",
    "#ffec99",
    "#ffe066",
    "#ffd43b",
    "#fcc419",
    "#fab005",
    "#f59f00",
    "#f08c00",
    "#e67700"
  ],
  orange: [
    "#fff4e6",
    "#ffe8cc",
    "#ffd8a8",
    "#ffc078",
    "#ffa94d",
    "#ff922b",
    "#fd7e14",
    "#f76707",
    "#e8590c",
    "#d9480f"
  ]
}, we = "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji", ze = {
  scale: 1,
  fontSmoothing: !0,
  focusRing: "auto",
  white: "#fff",
  black: "#000",
  colors: _r,
  primaryShade: { light: 6, dark: 8 },
  primaryColor: "blue",
  variantColorResolver: Tr,
  autoContrast: !1,
  luminanceThreshold: 0.3,
  fontFamily: we,
  fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
  respectReducedMotion: !1,
  cursorType: "default",
  defaultGradient: { from: "blue", to: "cyan", deg: 45 },
  defaultRadius: "sm",
  activeClassName: "mantine-active",
  focusClassName: "",
  headings: {
    fontFamily: we,
    fontWeight: "700",
    textWrap: "wrap",
    sizes: {
      h1: { fontSize: s(34), lineHeight: "1.3" },
      h2: { fontSize: s(26), lineHeight: "1.35" },
      h3: { fontSize: s(22), lineHeight: "1.4" },
      h4: { fontSize: s(18), lineHeight: "1.45" },
      h5: { fontSize: s(16), lineHeight: "1.5" },
      h6: { fontSize: s(14), lineHeight: "1.5" }
    }
  },
  fontSizes: {
    xs: s(12),
    sm: s(14),
    md: s(16),
    lg: s(18),
    xl: s(20)
  },
  lineHeights: {
    xs: "1.4",
    sm: "1.45",
    md: "1.55",
    lg: "1.6",
    xl: "1.65"
  },
  radius: {
    xs: s(2),
    sm: s(4),
    md: s(8),
    lg: s(16),
    xl: s(32)
  },
  spacing: {
    xs: s(10),
    sm: s(12),
    md: s(16),
    lg: s(20),
    xl: s(32)
  },
  breakpoints: {
    xs: "36em",
    sm: "48em",
    md: "62em",
    lg: "75em",
    xl: "88em"
  },
  shadows: {
    xs: `0 ${s(1)} ${s(3)} rgba(0, 0, 0, 0.05), 0 ${s(1)} ${s(2)} rgba(0, 0, 0, 0.1)`,
    sm: `0 ${s(1)} ${s(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${s(10)} ${s(
      15
    )} ${s(-5)}, rgba(0, 0, 0, 0.04) 0 ${s(7)} ${s(7)} ${s(-5)}`,
    md: `0 ${s(1)} ${s(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${s(20)} ${s(
      25
    )} ${s(-5)}, rgba(0, 0, 0, 0.04) 0 ${s(10)} ${s(10)} ${s(-5)}`,
    lg: `0 ${s(1)} ${s(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${s(28)} ${s(
      23
    )} ${s(-7)}, rgba(0, 0, 0, 0.04) 0 ${s(12)} ${s(12)} ${s(-7)}`,
    xl: `0 ${s(1)} ${s(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${s(36)} ${s(
      28
    )} ${s(-7)}, rgba(0, 0, 0, 0.04) 0 ${s(17)} ${s(17)} ${s(-7)}`
  },
  other: {},
  components: {}
}, kr = "[@mantine/core] MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more – https://mantine.dev/theming/colors/#primary-color", Ce = "[@mantine/core] MantineProvider: Invalid theme.primaryShade, it accepts only 0-9 integers or an object { light: 0-9, dark: 0-9 }";
function fe(e) {
  return e < 0 || e > 9 ? !1 : parseInt(e.toString(), 10) === e;
}
function Ne(e) {
  if (!(e.primaryColor in e.colors))
    throw new Error(kr);
  if (typeof e.primaryShade == "object" && (!fe(e.primaryShade.dark) || !fe(e.primaryShade.light)))
    throw new Error(Ce);
  if (typeof e.primaryShade == "number" && !fe(e.primaryShade))
    throw new Error(Ce);
}
function wr(e, r) {
  if (!r)
    return Ne(e), e;
  const t = Oe(e, r);
  return r.fontFamily && !r.headings?.fontFamily && (t.headings.fontFamily = r.fontFamily), Ne(t), t;
}
const $e = Me(null), Cr = () => ge($e) || ze;
function re() {
  const e = ge($e);
  if (!e)
    throw new Error(
      "@mantine/core: MantineProvider was not found in component tree, make sure you have it in your app"
    );
  return e;
}
function Nr({
  theme: e,
  children: r,
  inherit: t = !0
}) {
  const n = Cr(), o = nr(
    () => wr(t ? n : ze, e),
    [e, n, t]
  );
  return /* @__PURE__ */ T.jsx($e.Provider, { value: o, children: r });
}
Nr.displayName = "@mantine/core/MantineThemeProvider";
const Ar = {
  always: "mantine-focus-always",
  auto: "mantine-focus-auto",
  never: "mantine-focus-never"
};
function jr({ theme: e, options: r, unstyled: t }) {
  return K(
    r?.focusable && !t && (e.focusClassName || Ar[e.focusRing]),
    r?.active && !t && e.activeClassName
  );
}
function Pr({
  selector: e,
  stylesCtx: r,
  options: t,
  props: n,
  theme: o
}) {
  return he({
    theme: o,
    classNames: t?.classNames,
    props: t?.props || n,
    stylesCtx: r
  })[e];
}
function Ae({
  selector: e,
  stylesCtx: r,
  theme: t,
  classNames: n,
  props: o
}) {
  return he({ theme: t, classNames: n, props: o, stylesCtx: r })[e];
}
function Mr({ rootSelector: e, selector: r, className: t }) {
  return e === r ? t : void 0;
}
function Or({ selector: e, classes: r, unstyled: t }) {
  return t ? void 0 : r[e];
}
function Ir({
  themeName: e,
  classNamesPrefix: r,
  selector: t,
  withStaticClass: n
}) {
  return n === !1 ? [] : e.map((o) => `${r}-${o}-${t}`);
}
function Fr({
  themeName: e,
  theme: r,
  selector: t,
  props: n,
  stylesCtx: o
}) {
  return e.map(
    (a) => he({
      theme: r,
      classNames: r.components[a]?.classNames,
      props: n,
      stylesCtx: o
    })?.[t]
  );
}
function Lr({
  options: e,
  classes: r,
  selector: t,
  unstyled: n
}) {
  return e?.variant && !n ? r[`${t}--${e.variant}`] : void 0;
}
function zr({
  theme: e,
  options: r,
  themeName: t,
  selector: n,
  classNamesPrefix: o,
  classNames: a,
  classes: c,
  unstyled: f,
  className: u,
  rootSelector: p,
  props: m,
  stylesCtx: d,
  withStaticClasses: g,
  headless: b,
  transformedStyles: S
}) {
  return K(
    jr({ theme: e, options: r, unstyled: f || b }),
    Fr({ theme: e, themeName: t, selector: n, props: m, stylesCtx: d }),
    Lr({ options: r, classes: c, selector: n, unstyled: f }),
    Ae({ selector: n, stylesCtx: d, theme: e, classNames: a, props: m }),
    Ae({ selector: n, stylesCtx: d, theme: e, classNames: S, props: m }),
    Pr({ selector: n, stylesCtx: d, options: r, props: m, theme: e }),
    Mr({ rootSelector: p, selector: n, className: u }),
    Or({ selector: n, classes: c, unstyled: f || b }),
    g && !b && Ir({
      themeName: t,
      classNamesPrefix: o,
      selector: n,
      withStaticClass: r?.withStaticClass
    }),
    r?.className
  );
}
function Wr({
  theme: e,
  themeName: r,
  props: t,
  stylesCtx: n,
  selector: o
}) {
  return r.map(
    (a) => de({
      theme: e,
      styles: e.components[a]?.styles,
      props: t,
      stylesCtx: n
    })[o]
  ).reduce((a, c) => ({ ...a, ...c }), {});
}
function pe({ style: e, theme: r }) {
  return Array.isArray(e) ? [...e].reduce(
    (t, n) => ({ ...t, ...pe({ style: n, theme: r }) }),
    {}
  ) : typeof e == "function" ? e(r) : e ?? {};
}
function Hr(e) {
  return e.reduce((r, t) => (t && Object.keys(t).forEach((n) => {
    r[n] = { ...r[n], ...be(t[n]) };
  }), r), {});
}
function Yr({
  vars: e,
  varsResolver: r,
  theme: t,
  props: n,
  stylesCtx: o,
  selector: a,
  themeName: c,
  headless: f
}) {
  return Hr([
    f ? {} : r?.(t, n, o),
    ...c.map((u) => t.components?.[u]?.vars?.(t, n, o)),
    e?.(t, n, o)
  ])?.[a];
}
function Dr({
  theme: e,
  themeName: r,
  selector: t,
  options: n,
  props: o,
  stylesCtx: a,
  rootSelector: c,
  styles: f,
  style: u,
  vars: p,
  varsResolver: m,
  headless: d,
  withStylesTransform: g
}) {
  return {
    ...!g && Wr({ theme: e, themeName: r, props: o, stylesCtx: a, selector: t }),
    ...!g && de({ theme: e, styles: f, props: o, stylesCtx: a })[t],
    ...!g && de({ theme: e, styles: n?.styles, props: n?.props || o, stylesCtx: a })[t],
    ...Yr({ theme: e, props: o, stylesCtx: a, vars: p, varsResolver: m, selector: t, themeName: r, headless: d }),
    ...c === t ? pe({ style: u, theme: e }) : null,
    ...pe({ style: n?.style, theme: e })
  };
}
function Br({ props: e, stylesCtx: r, themeName: t }) {
  const n = re(), o = br()?.();
  return {
    getTransformedStyles: (c) => o ? [
      ...c.map(
        (u) => o(u, { props: e, theme: n, ctx: r })
      ),
      ...t.map(
        (u) => o(n.components[u]?.styles, { props: e, theme: n, ctx: r })
      )
    ].filter(Boolean) : [],
    withStylesTransform: !!o
  };
}
function Ur({
  name: e,
  classes: r,
  props: t,
  stylesCtx: n,
  className: o,
  style: a,
  rootSelector: c = "root",
  unstyled: f,
  classNames: u,
  styles: p,
  vars: m,
  varsResolver: d,
  attributes: g
}) {
  const b = re(), S = dr(), w = mr(), R = gr(), x = (Array.isArray(e) ? e : [e]).filter(($) => $), { withStylesTransform: A, getTransformedStyles: j } = Br({
    props: t,
    stylesCtx: n,
    themeName: x
  });
  return ($, E) => ({
    className: zr({
      theme: b,
      options: E,
      themeName: x,
      selector: $,
      classNamesPrefix: S,
      classNames: u,
      classes: r,
      unstyled: f,
      className: o,
      rootSelector: c,
      props: t,
      stylesCtx: n,
      withStaticClasses: w,
      headless: R,
      transformedStyles: j([E?.styles, p])
    }),
    style: Dr({
      theme: b,
      themeName: x,
      selector: $,
      options: E,
      props: t,
      stylesCtx: n,
      rootSelector: c,
      styles: p,
      style: a,
      vars: m,
      varsResolver: d,
      headless: R,
      withStylesTransform: A
    }),
    ...g?.[$]
  });
}
function Vr(e, r, t) {
  const n = re(), o = n.components[e]?.defaultProps, a = typeof o == "function" ? o(n) : o;
  return { ...r, ...a, ...be(t) };
}
function le(e) {
  return ye(e).reduce(
    (r, t) => e[t] !== void 0 ? `${r}${ar(t)}:${e[t]};` : r,
    ""
  ).trim();
}
function qr({ selector: e, styles: r, media: t, container: n }) {
  const o = r ? le(r) : "", a = Array.isArray(t) ? t.map((f) => `@media${f.query}{${e}{${le(f.styles)}}}`) : [], c = Array.isArray(n) ? n.map(
    (f) => `@container ${f.query}{${e}{${le(f.styles)}}}`
  ) : [];
  return `${o ? `${e}{${o}}` : ""}${a.join("")}${c.join("")}`.trim();
}
function Gr(e) {
  const r = pr();
  return /* @__PURE__ */ T.jsx(
    "style",
    {
      "data-mantine-styles": "inline",
      nonce: r?.(),
      dangerouslySetInnerHTML: { __html: qr(e) }
    }
  );
}
function Jr(e) {
  const {
    m: r,
    mx: t,
    my: n,
    mt: o,
    mb: a,
    ml: c,
    mr: f,
    me: u,
    ms: p,
    p: m,
    px: d,
    py: g,
    pt: b,
    pb: S,
    pl: w,
    pr: R,
    pe: x,
    ps: A,
    bd: j,
    bdrs: $,
    bg: E,
    c: _,
    opacity: P,
    ff: te,
    fz: I,
    fw: ne,
    lts: oe,
    ta: F,
    lh: U,
    fs: ae,
    tt: L,
    td: V,
    w: q,
    miw: G,
    maw: J,
    h: X,
    mih: i,
    mah: l,
    bgsz: y,
    bgp: h,
    bgr: M,
    bga: z,
    pos: v,
    top: C,
    left: W,
    bottom: ie,
    right: Ve,
    inset: qe,
    display: Ge,
    flex: Je,
    hiddenFrom: Xe,
    visibleFrom: Qe,
    lightHidden: Ze,
    darkHidden: Ke,
    sx: er,
    ...rr
  } = e;
  return { styleProps: be({
    m: r,
    mx: t,
    my: n,
    mt: o,
    mb: a,
    ml: c,
    mr: f,
    me: u,
    ms: p,
    p: m,
    px: d,
    py: g,
    pt: b,
    pb: S,
    pl: w,
    pr: R,
    pe: x,
    ps: A,
    bd: j,
    bg: E,
    c: _,
    opacity: P,
    ff: te,
    fz: I,
    fw: ne,
    lts: oe,
    ta: F,
    lh: U,
    fs: ae,
    tt: L,
    td: V,
    w: q,
    miw: G,
    maw: J,
    h: X,
    mih: i,
    mah: l,
    bgsz: y,
    bgp: h,
    bgr: M,
    bga: z,
    pos: v,
    top: C,
    left: W,
    bottom: ie,
    right: Ve,
    inset: qe,
    display: Ge,
    flex: Je,
    bdrs: $,
    hiddenFrom: Xe,
    visibleFrom: Qe,
    lightHidden: Ze,
    darkHidden: Ke,
    sx: er
  }), rest: rr };
}
const Xr = {
  m: { type: "spacing", property: "margin" },
  mt: { type: "spacing", property: "marginTop" },
  mb: { type: "spacing", property: "marginBottom" },
  ml: { type: "spacing", property: "marginLeft" },
  mr: { type: "spacing", property: "marginRight" },
  ms: { type: "spacing", property: "marginInlineStart" },
  me: { type: "spacing", property: "marginInlineEnd" },
  mx: { type: "spacing", property: "marginInline" },
  my: { type: "spacing", property: "marginBlock" },
  p: { type: "spacing", property: "padding" },
  pt: { type: "spacing", property: "paddingTop" },
  pb: { type: "spacing", property: "paddingBottom" },
  pl: { type: "spacing", property: "paddingLeft" },
  pr: { type: "spacing", property: "paddingRight" },
  ps: { type: "spacing", property: "paddingInlineStart" },
  pe: { type: "spacing", property: "paddingInlineEnd" },
  px: { type: "spacing", property: "paddingInline" },
  py: { type: "spacing", property: "paddingBlock" },
  bd: { type: "border", property: "border" },
  bdrs: { type: "radius", property: "borderRadius" },
  bg: { type: "color", property: "background" },
  c: { type: "textColor", property: "color" },
  opacity: { type: "identity", property: "opacity" },
  ff: { type: "fontFamily", property: "fontFamily" },
  fz: { type: "fontSize", property: "fontSize" },
  fw: { type: "identity", property: "fontWeight" },
  lts: { type: "size", property: "letterSpacing" },
  ta: { type: "identity", property: "textAlign" },
  lh: { type: "lineHeight", property: "lineHeight" },
  fs: { type: "identity", property: "fontStyle" },
  tt: { type: "identity", property: "textTransform" },
  td: { type: "identity", property: "textDecoration" },
  w: { type: "spacing", property: "width" },
  miw: { type: "spacing", property: "minWidth" },
  maw: { type: "spacing", property: "maxWidth" },
  h: { type: "spacing", property: "height" },
  mih: { type: "spacing", property: "minHeight" },
  mah: { type: "spacing", property: "maxHeight" },
  bgsz: { type: "size", property: "backgroundSize" },
  bgp: { type: "identity", property: "backgroundPosition" },
  bgr: { type: "identity", property: "backgroundRepeat" },
  bga: { type: "identity", property: "backgroundAttachment" },
  pos: { type: "identity", property: "position" },
  top: { type: "size", property: "top" },
  left: { type: "size", property: "left" },
  bottom: { type: "size", property: "bottom" },
  right: { type: "size", property: "right" },
  inset: { type: "size", property: "inset" },
  display: { type: "identity", property: "display" },
  flex: { type: "identity", property: "flex" }
};
function Se(e, r) {
  const t = ee({ color: e, theme: r });
  return t.color === "dimmed" ? "var(--mantine-color-dimmed)" : t.color === "bright" ? "var(--mantine-color-bright)" : t.variable ? `var(${t.variable})` : t.color;
}
function Qr(e, r) {
  const t = ee({ color: e, theme: r });
  return t.isThemeColor && t.shade === void 0 ? `var(--mantine-color-${t.color}-text)` : Se(e, r);
}
function Zr(e, r) {
  if (typeof e == "number")
    return s(e);
  if (typeof e == "string") {
    const [t, n, ...o] = e.split(" ").filter((c) => c.trim() !== "");
    let a = `${s(t)}`;
    return n && (a += ` ${n}`), o.length > 0 && (a += ` ${Se(o.join(" "), r)}`), a.trim();
  }
  return e;
}
const je = {
  text: "var(--mantine-font-family)",
  mono: "var(--mantine-font-family-monospace)",
  monospace: "var(--mantine-font-family-monospace)",
  heading: "var(--mantine-font-family-headings)",
  headings: "var(--mantine-font-family-headings)"
};
function Kr(e) {
  return typeof e == "string" && e in je ? je[e] : e;
}
const et = ["h1", "h2", "h3", "h4", "h5", "h6"];
function rt(e, r) {
  return typeof e == "string" && e in r.fontSizes ? `var(--mantine-font-size-${e})` : typeof e == "string" && et.includes(e) ? `var(--mantine-${e}-font-size)` : typeof e == "number" || typeof e == "string" ? s(e) : e;
}
function tt(e) {
  return e;
}
const nt = ["h1", "h2", "h3", "h4", "h5", "h6"];
function ot(e, r) {
  return typeof e == "string" && e in r.lineHeights ? `var(--mantine-line-height-${e})` : typeof e == "string" && nt.includes(e) ? `var(--mantine-${e}-line-height)` : e;
}
function at(e, r) {
  return typeof e == "string" && e in r.radius ? `var(--mantine-radius-${e})` : typeof e == "number" || typeof e == "string" ? s(e) : e;
}
function it(e) {
  return typeof e == "number" ? s(e) : e;
}
function st(e, r) {
  if (typeof e == "number")
    return s(e);
  if (typeof e == "string") {
    const t = e.replace("-", "");
    if (!(t in r.spacing))
      return s(e);
    const n = `--mantine-spacing-${t}`;
    return e.startsWith("-") ? `calc(var(${n}) * -1)` : `var(${n})`;
  }
  return e;
}
const ue = {
  color: Se,
  textColor: Qr,
  fontSize: rt,
  spacing: st,
  radius: at,
  identity: tt,
  size: it,
  lineHeight: ot,
  fontFamily: Kr,
  border: Zr
};
function Pe(e) {
  return e.replace("(min-width: ", "").replace("em)", "");
}
function ct({
  media: e,
  ...r
}) {
  const n = Object.keys(e).sort((o, a) => Number(Pe(o)) - Number(Pe(a))).map((o) => ({ query: o, styles: e[o] }));
  return { ...r, media: n };
}
function ft(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const r = Object.keys(e);
  return !(r.length === 1 && r[0] === "base");
}
function lt(e) {
  return typeof e == "object" && e !== null ? "base" in e ? e.base : void 0 : e;
}
function ut(e) {
  return typeof e == "object" && e !== null ? ye(e).filter((r) => r !== "base") : [];
}
function dt(e, r) {
  return typeof e == "object" && e !== null && r in e ? e[r] : e;
}
function pt({
  styleProps: e,
  data: r,
  theme: t
}) {
  return ct(
    ye(e).reduce(
      (n, o) => {
        if (o === "hiddenFrom" || o === "visibleFrom" || o === "sx")
          return n;
        const a = r[o], c = Array.isArray(a.property) ? a.property : [a.property], f = lt(e[o]);
        if (!ft(e[o]))
          return c.forEach((p) => {
            n.inlineStyles[p] = ue[a.type](f, t);
          }), n;
        n.hasResponsiveStyles = !0;
        const u = ut(e[o]);
        return c.forEach((p) => {
          f != null && (n.styles[p] = ue[a.type](f, t)), u.forEach((m) => {
            const d = `(min-width: ${t.breakpoints[m]})`;
            n.media[d] = {
              ...n.media[d],
              [p]: ue[a.type](
                dt(e[o], m),
                t
              )
            };
          });
        }), n;
      },
      {
        hasResponsiveStyles: !1,
        styles: {},
        inlineStyles: {},
        media: {}
      }
    )
  );
}
function mt() {
  return `__m__-${or().replace(/[:«»]/g, "")}`;
}
function jt(e) {
  return e;
}
function We(e) {
  return e.startsWith("data-") ? e : `data-${e}`;
}
function gt(e) {
  return Object.keys(e).reduce((r, t) => {
    const n = e[t];
    return n === void 0 || n === "" || n === !1 || n === null || (r[We(t)] = e[t]), r;
  }, {});
}
function He(e) {
  return e ? typeof e == "string" ? { [We(e)]: !0 } : Array.isArray(e) ? [...e].reduce(
    (r, t) => ({ ...r, ...He(t) }),
    {}
  ) : gt(e) : null;
}
function me(e, r) {
  return Array.isArray(e) ? [...e].reduce(
    (t, n) => ({ ...t, ...me(n, r) }),
    {}
  ) : typeof e == "function" ? e(r) : e ?? {};
}
function yt({
  theme: e,
  style: r,
  vars: t,
  styleProps: n
}) {
  const o = me(r, e), a = me(t, e);
  return { ...o, ...a, ...n };
}
const Ye = O(
  ({
    component: e,
    style: r,
    __vars: t,
    className: n,
    variant: o,
    mod: a,
    size: c,
    hiddenFrom: f,
    visibleFrom: u,
    lightHidden: p,
    darkHidden: m,
    renderRoot: d,
    __size: g,
    ...b
  }, S) => {
    const w = re(), R = e || "div", { styleProps: x, rest: A } = Jr(b), $ = yr()?.()?.(x.sx), E = mt(), _ = pt({
      styleProps: x,
      theme: w,
      data: Xr
    }), P = {
      ref: S,
      style: yt({
        theme: w,
        style: r,
        vars: t,
        styleProps: _.inlineStyles
      }),
      className: K(n, $, {
        [E]: _.hasResponsiveStyles,
        "mantine-light-hidden": p,
        "mantine-dark-hidden": m,
        [`mantine-hidden-from-${f}`]: f,
        [`mantine-visible-from-${u}`]: u
      }),
      "data-variant": o,
      "data-size": Fe(c) ? void 0 : c || void 0,
      size: g,
      ...He(a),
      ...A
    };
    return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
      _.hasResponsiveStyles && /* @__PURE__ */ T.jsx(
        Gr,
        {
          selector: `.${E}`,
          styles: _.styles,
          media: _.media
        }
      ),
      typeof d == "function" ? d(P) : /* @__PURE__ */ T.jsx(R, { ...P })
    ] });
  }
);
Ye.displayName = "@mantine/core/Box";
const bt = Ye;
function De(e) {
  return e;
}
function Pt(e) {
  const r = e;
  return (t) => {
    const n = O((o, a) => /* @__PURE__ */ T.jsx(r, { ...t, ...o, ref: a }));
    return n.extend = r.extend, n.displayName = `WithProps(${r.displayName})`, n;
  };
}
function Mt(e) {
  const r = O(e);
  return r.extend = De, r.withProps = (t) => {
    const n = O((o, a) => /* @__PURE__ */ T.jsx(r, { ...t, ...o, ref: a }));
    return n.extend = r.extend, n.displayName = `WithProps(${r.displayName})`, n;
  }, r;
}
function ht(e) {
  const r = O(e);
  return r.withProps = (t) => {
    const n = O((o, a) => /* @__PURE__ */ T.jsx(r, { ...t, ...o, ref: a }));
    return n.extend = r.extend, n.displayName = `WithProps(${r.displayName})`, n;
  }, r.extend = De, r;
}
var Be = { root: "m_87cf2631" };
const vt = {
  __staticSelector: "UnstyledButton"
}, Ue = ht(
  (e, r) => {
    const t = Vr("UnstyledButton", vt, e), {
      className: n,
      component: o = "button",
      __staticSelector: a,
      unstyled: c,
      classNames: f,
      styles: u,
      style: p,
      attributes: m,
      ...d
    } = t, g = Ur({
      name: a,
      props: t,
      classes: Be,
      className: n,
      style: p,
      classNames: f,
      styles: u,
      unstyled: c,
      attributes: m
    });
    return /* @__PURE__ */ T.jsx(
      bt,
      {
        ...g("root", { focusable: !0 }),
        component: o,
        ref: r,
        type: o === "button" ? "button" : void 0,
        ...d
      }
    );
  }
);
Ue.classes = Be;
Ue.displayName = "@mantine/core/UnstyledButton";
export {
  wr as A,
  bt as B,
  mt as C,
  ze as D,
  pt as E,
  be as F,
  K as G,
  jt as H,
  Gr as I,
  kt as J,
  ke as K,
  _t as L,
  ur as M,
  Er as N,
  de as O,
  he as P,
  k as Q,
  Nt as R,
  Ue as U,
  pr as a,
  At as b,
  Ct as c,
  Oe as d,
  Rt as e,
  Nr as f,
  Rr as g,
  Mt as h,
  Vr as i,
  T as j,
  ye as k,
  Ur as l,
  wt as m,
  Et as n,
  Pt as o,
  ht as p,
  _e as q,
  s as r,
  B as s,
  xt as t,
  re as u,
  Jr as v,
  Tt as w,
  ee as x,
  Tr as y,
  Z as z
};
